import React from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Hero } from "../components/Hero";
import { Features } from "../components/Features";
import { EventDetails } from "../components/EventDetails";
import { SponsorsPreview } from "../components/Sponsors";
import { GetInvolved } from "../components/GetInvolved";
import { Skyline } from "../components/Decor";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <Hero />
      <Skyline />
      <Features />
      <EventDetails />
      <SponsorsPreview />
      <GetInvolved />
      <Footer />
    </div>
  );
}
